import { useState } from 'react';
import { Form } from 'components/Form';
import { InputField } from 'components/InputField';
import { logInUser } from 'apiCalls/apiCalls';
import { useAuthContext } from 'context/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { Flexbox } from 'components/Flexbox';
import { Heading } from 'components/CommonComponents';
import { PrimaryButton } from 'components/Buttons';
import { Grid, GridItem } from 'components/Grid';
import {
    BORDER_RADIUS_NUMBER,
    COLOURS_EXTRA_LIGHT,
    PAD_EXTRA_EXTRA_LARGE_NUMBER,
    PAD_EXTRA_LARGE_NUMBER,
} from 'providers/designSystem';
import { CenteredContent } from 'components/CenteredContent';
import { Box } from '@mui/material';

export const LogInUser = () => {
    const [username, setUserName] = useState(null);
    const [password, setPassword] = useState(null);
    const [, setIsAuthenticated] = useAuthContext();
    const navigate = useNavigate();

    const setUserNameFromInput = e => {
        setUserName(e.target.value);
    };

    const setPasswordFromInput = e => {
        setPassword(e.target.value);
    };

    const submitLogInUserForm = async event => {
        event.preventDefault();

        try {
            await logInUser(username, password);
            setIsAuthenticated(true);
            navigate('/colour-palettes');
        } catch (e) {
            window.alert(e.message);
        }
    };

    return (
        <>
            <GridItem justifySelf="center">
                <Heading>Log in User</Heading>
            </GridItem>

            <Form onSubmit={submitLogInUserForm}>
                <InputField label="Username" onChange={setUserNameFromInput} />
                <InputField label="Password" onChange={setPasswordFromInput} type="password" />
                <PrimaryButton onClick={() => {}}>Log In</PrimaryButton>
            </Form>
        </>
    );
};

export const LoginPage = () => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                position: 'relative',
                top: '-8px',
            }}
        >
            <CenteredContent height="80vh">
                <Grid
                    numberOfColumns={1}
                    gap={PAD_EXTRA_LARGE_NUMBER}
                    backgroundColour={COLOURS_EXTRA_LIGHT.violet}
                    borderRadius={BORDER_RADIUS_NUMBER}
                    paddingX={PAD_EXTRA_LARGE_NUMBER}
                    paddingY={PAD_EXTRA_EXTRA_LARGE_NUMBER}
                    width="480px"
                >
                    <LogInUser />
                    <GridItem justifySelf="center">
                        <Flexbox gap={4}>
                            <p>Don't have an account? </p>
                            <button onClick={() => navigate('/create-account')}>Sign up here</button>
                        </Flexbox>
                    </GridItem>
                </Grid>
            </CenteredContent>
        </Box>
    );
};
